import { render, staticRenderFns } from "./MembersPublicity.vue?vue&type=template&id=6ccb67c7&scoped=true&"
import script from "./MembersPublicity.vue?vue&type=script&lang=js&"
export * from "./MembersPublicity.vue?vue&type=script&lang=js&"
import style0 from "./MembersPublicity.vue?vue&type=style&index=0&id=6ccb67c7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccb67c7",
  null
  
)

export default component.exports